import { getRecord } from "./getRecord";
import { stash, tables } from "./stash";

export function getMatchTimeLeft(latestBlockTimestamp: bigint) {
  const matchDuration = getRecord({ state: stash.get(), table: tables.MatchConfig, key: [] })?.matchDuration ?? 0n;

  if (latestBlockTimestamp === 0n) return matchDuration;

  const matchId = getRecord({ state: stash.get(), table: tables.MatchCounter, key: [] })?.value ?? 0;

  const matchCreated =
    getRecord({
      state: stash.get(),
      table: tables.Match,
      key: { id: matchId },
    })?.createdTimestamp ?? 0n;

  return Math.max(0, Math.floor(Number(matchCreated) + Number(matchDuration) - Number(latestBlockTimestamp)));
}
